import React from 'react';

export default function useSetElementAccessible(element, { onFocus, onBlur }) {
  React.useEffect(() => {
    if (element) {
      element.addEventListener('focus', onFocus);
      element.addEventListener('blur', onBlur);
    }

    return () => {
      if (element) {
        element.removeEventListener('focus', onFocus);
        element.removeEventListener('blur', onBlur);
      }
    };
  }, [element, onBlur, onFocus]);
}
